import { Navigate, useLocation } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { useAuth } from '@/hooks/useAuth'
import { APP_ROUTE, normalizeAppRoute } from '@/lib/routes'

interface RedirectOnboardedUserProps {
  children: React.ReactNode
}

const getRedirectTarget = (from: unknown) => {
  if (
    from &&
    typeof from === 'object' &&
    'pathname' in from &&
    typeof from.pathname === 'string' &&
    from.pathname !== '/onboarding'
  ) {
    const search = 'search' in from && typeof from.search === 'string' ? from.search : ''
    const hash = 'hash' in from && typeof from.hash === 'string' ? from.hash : ''

    return normalizeAppRoute(`${from.pathname}${search}${hash}`)
  }

  return APP_ROUTE
}

export function RedirectOnboardedUser({ children }: RedirectOnboardedUserProps) {
  const { loading, profile } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    )
  }

  if (profile?.onboarding_completed_at) {
    return <Navigate to={getRedirectTarget(location.state?.from)} replace />
  }

  return <>{children}</>
}
